@if (!embedded()) {
<mat-card appearance="outlined" class="ai-card">
  <app-card-header [displayName]="ref().filename" rawName="file">
    <app-type-chip [type]="chipType()" />
  </app-card-header>
  <ng-container *ngTemplateOutlet="cardBody" />
</mat-card>
} @else {
  <ng-container *ngTemplateOutlet="cardBody" />
}

<ng-template #cardBody>

  <mat-card-content class="px-3 pt-2 pb-2" [class.border-top]="embedded() && borderTop()">

    <!-- IMAGE: show thumbnail immediately, fetch from preview_url if available -->
    @if (isImage()) {
      @if (thumbnailSrc()) {
        <img class="file-block-card__preview" [src]="thumbnailSrc()!" [alt]="ref().filename" />
      } @else {
        <div class="d-flex align-items-center gap-2 py-2 text-body-secondary">
          <mat-progress-spinner diameter="20" mode="indeterminate" />
          <span class="mat-font-label-sm">Loading preview…</span>
        </div>
      }

    <!-- FETCH-REQUIRED: geojson, json, text, geotiff -->
    } @else if (needsFetch()) {
      @if (fetchState() === 'loading') {
        <div class="d-flex align-items-center gap-2 py-2 text-body-secondary">
          <mat-progress-spinner diameter="20" mode="indeterminate" />
          <span class="mat-font-label-sm">Loading…</span>
        </div>
      } @else if (fetchState() === 'loaded' && loadedResult()) {
        <app-content-data-viewer [data]="loadedResult()!" />
      } @else if (fetchState() === 'error') {
        <div class="d-flex align-items-center gap-2 py-2 text-body-secondary">
          <mat-icon>error_outline</mat-icon>
          <span class="mat-font-label-sm">{{ fetchError() }}</span>
        </div>
      } @else {
        <!-- idle + too large or geotiff: show load button -->
        <div class="d-flex align-items-center gap-2 py-2">
          <mat-icon class="text-body-secondary">description</mat-icon>
          <span class="mat-font-label-sm text-body-secondary flex-fill">{{ sizeLabel() }}</span>
          <button mat-button (click)="loadContent()">
            <mat-icon>visibility</mat-icon>
            Load
          </button>
        </div>
      }

    <!-- PDF, BINARY: ContentDataViewer handles icon + action bar handles download -->
    } @else {
      <app-content-data-viewer [data]="immediateResult()!" />
    }

  </mat-card-content>

  <!-- Size chip: always for images; for others only once content is loaded (idle row already shows size) -->
  @if ((sizeLabel() && (isImage() || fetchState() === 'loaded')) || geojsonFeatureCount() !== null) {
    <div class="px-3 pb-2 d-flex flex-wrap gap-1">
      @if (sizeLabel() && (isImage() || fetchState() === 'loaded')) {
        <mat-chip>{{ sizeLabel() }}</mat-chip>
      }
      @if (geojsonFeatureCount() !== null) {
        <mat-chip>{{ geojsonFeatureCount() }} features</mat-chip>
      }
    </div>
  }

  @if (capabilities().length > 0) {
    <div class="ai-card__footer px-2 py-1 d-flex align-items-center">
      <app-content-action-bar
        [capabilities]="capabilities()"
        [debugMode]="debugMode.isDebugMode()"
        (actionTriggered)="onAction($event)" />
    </div>
  }

</ng-template>
